import { render, staticRenderFns } from "./addSchool.vue?vue&type=template&id=b2ab0666&"
import script from "./addSchool.vue?vue&type=script&lang=js&"
export * from "./addSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports